var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"hl-variation-list"},[_vm._v(" "+_vm._s(_vm.$t("Set.Item.Description.shutter"))+" ")]),_c('ul',{staticClass:"default-option-list"},[_vm._l((_vm.shutterList),function(item,index){return [_c('li',{key:index,class:{ match: item.match },on:{"click":function($event){return _vm.changeItem(item.itemnumber, item.alerts)}}},[_c('img',{staticClass:"thumb",attrs:{"src":_vm.appUrl +
            '/img/assets/shutters/' +
            index.toLowerCase() +
            '_' +
            item.color.toLowerCase() +
            '.jpg',"srcset":_vm.appUrl +
            '/img/assets/shutters/' +
            index.toLowerCase() +
            '_' +
            item.color.toLowerCase() +
            '@2x.jpg',"alt":item.text}}),_c('p',[_vm._v("("+_vm._s(index)+") "+_vm._s(item.text))])])]}),(!_vm.all)?_c('li',{on:{"click":function($event){_vm.all = true}}},[_c('img',{staticClass:"thumb",attrs:{"src":_vm.appUrl + '/img/icons/next.svg'}}),_c('span',[_vm._v(_vm._s(_vm.$t("Menu.list.profiles.more"))+" >")])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }